module.exports = new __parcel__URL__("logo-light.cb2042ed.png").toString();